import { render, staticRenderFns } from "./getCode.vue?vue&type=template&id=60dd1d29&scoped=true"
import script from "./getCode.vue?vue&type=script&lang=js"
export * from "./getCode.vue?vue&type=script&lang=js"
import style0 from "./getCode.vue?vue&type=style&index=0&id=60dd1d29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd1d29",
  null
  
)

export default component.exports